import { Injectable } from '@angular/core';

import { FORECAST_ROUTES_FEATURE_FLAGS } from '@shared/constants/feature-flags-guards/forecast-routes-feature-flags.const';
import { ROUTING_PATH } from '@shared/constants/routingPath';
import { BasicRedirectToNextTabGuard } from '@shared/guards/basic-redirect-to-next-tab.guard';
import { Flags } from '@shared/services/launch-darkly.service';

@Injectable({
  providedIn: 'root',
})
export class ForecastGuard extends BasicRedirectToNextTabGuard {
  protected prefix = `/${ROUTING_PATH.FORECAST_ROUTING.INDEX}`;
  protected defaultNavigateUrl = `${this.prefix}/${ROUTING_PATH.FORECAST_ROUTING.TIMELINE}`;
  protected featureFlag = 'forecast_methodology_tab' as keyof Flags;
  protected routerPathsAndFeatureFlags = FORECAST_ROUTES_FEATURE_FLAGS;
}
